import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class VMsg_zh_CN {
static load() {

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: ZH (Chinese, 中文 (Zhōngwén), 汉语, 漢語)
 */
$.extend( $.validator.messages, {
	required: "这是必填字段",
	remote: "请修正此字段",
	email: "请输入有效的电子邮件地址",
	url: "请输入有效的网址",
	date: "请输入有效的日期",
	dateISO: "请输入有效的日期 (YYYY-MM-DD)",
	number: "请输入有效的数字",
	digits: "只能输入数字",
	creditcard: "请输入有效的信用卡号码",
	equalTo: "你的输入不相同",
	extension: "请选择有效后缀的文件",
	maxlength: $.validator.format( "最多可以输入 {0} 个字符" ),
	minlength: $.validator.format( "最少要输入 {0} 个字符" ),
	rangelength: $.validator.format( "请输入长度在 {0} 到 {1} 之间的字符串" ),
	range: $.validator.format( "请输入范围在 {0} 到 {1} 之间的数值" ),
	max: $.validator.format( "请输入不大于 {0} 的数值" ),
	min: $.validator.format( "请输入不小于 {0} 的数值" ),
	step: $.validator.format( "请输入{0}整数倍的数字." ),
	accept: "请选择有效后缀的文件",
	alphanumeric: "只能输入英文字符数字下划线",
	integer: "请输入整数",
	ipv4: "请输入有效的IPv4地址",
	ipv6: "请输入有效的IPv6地址",
	lettersonly: "只能输入英文字符",
	letterswithbasicpunc: "只能输入英文字符和符号",
	notEqualTo: "你的输入相同",
	nowhitespace: "不能输入空白字符",
	pattern: $.validator.format( "无效格式 ({0})" ),
	time: "请输入有效的时间",
	url2: "请输入有效的网址",
	minbytelength: $.validator.format( "最少要输入 {0} 个半角长度" ),
	maxByteLength: $.validator.format( "最多可以输入 {0} 个半角长度" ),
	rangeByteLength: $.validator.format( "请输入长度在 {0} 到 {1} 之间的半角长度" ),
	halfWidth: "请输入半角字符",
	fullWidth: "请输入全角字符",
	kanji: "请输入半角汉字",
	kana: "请输入假名",
	hiragana: "请输入平假名",
	katakana: "请输入片假名",
	halfKatakana: "请输入半角片假名",
	fullKatakana: "请输入全角片假名",
	date_yyyyMMdd: "请输入有效的日期 (yyyyMMdd)",
	date_yyyy_MM_dd: "请输入有效的日期 (yyyy/MM/dd)",
	date_yyyy_MM: "请输入有效的年月 (yyyy/MM)",
	date_yyyyMM: "请输入有效的年月 (yyyyMM)",
	date_MM_dd: "请输入有效的日期 (MM/dd)",
	date_MMdd: "请输入有效的日期 (MMdd)",
	time_HH_mm: "请输入有效的时间 (HH:mm)",
	time_HH_mm_ss: "请输入有效的时间 (HH:mm:ss)",
	time_HHmmss: "请输入有效的时间 (HHmmss)",
	phoneJP: "请输入有效的电话号码",
	mobileJP: "请输入有效的手机号码",
	numberLessThen: "请输入相比较小些的数",
	numberLessEqualTo: "请输入相比较相同或小些的数",
	dateLessThen: "请输入相比较早些的时间",
	dateLessEqualTo: "请输入相比较相同或早些的时间",
	pwd: "请输入数字,英文字符和符号[@#$%]。三种都不可少"
} );
}
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/resources/validate_zh-CN.ts